import { useQuery, useQueryClient } from '@tanstack/react-query';
import api from '../../services/api';

export interface UserAvatarData {
  avatarUrl: string | null;
}

/**
 * Hook to fetch user avatar URL
 * Cached indefinitely - only invalidated on profile update
 */
export function useUserAvatar() {
  return useQuery({
    queryKey: ['user', 'avatar'],
    queryFn: async (): Promise<UserAvatarData> => {
      const response = await api.get('/api/auth/profile/avatar');

      return {
        avatarUrl: response.data?.avatarUrl || null
      };
    },
    staleTime: Infinity, // Never mark as stale automatically
    gcTime: Infinity, // Keep in cache forever
    retry: 1,
  });
}

/**
 * Hook to invalidate avatar cache (call after profile update)
 */
export function useInvalidateAvatar() {
  const queryClient = useQueryClient();

  return () => {
    queryClient.invalidateQueries({ queryKey: ['user', 'avatar'] });
  };
}
